import { useQuery } from '@tanstack/react-query';
import { PreviewEffectiveRateRequest } from 'src/api/FiretrolApiClient';
import { timesheetApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export interface EffectiveRateParams {
  userId: number;
  jobId: number;
  payCodeId: string;
  wbsAccountId?: string;
}

/**
 * @registry Server-calculated effective pay rate for a timesheet row, with the
 * breakdown instructions the rate popover renders.
 */
export function useEffectiveRate({
  userId,
  jobId,
  payCodeId,
  wbsAccountId,
}: EffectiveRateParams) {
  const request: PreviewEffectiveRateRequest = {
    userId,
    jobId,
    payCodeId,
    wbsAccountId: wbsAccountId || undefined,
  };

  return useQuery({
    queryKey: queryKeys.timesheets.effectiveRate(request),
    queryFn: ({ signal }) =>
      timesheetApiClient.previewEffectiveRate(request, toCancelToken(signal)),
    enabled: !!userId && !!jobId && !!payCodeId,
    staleTime: 60_000,
    meta: { suppressErrorToast: true, errorContext: 'effective rate preview' },
  });
}
